import React from 'react';
import { AddFilterModalProps } from './types';
import { styles } from './styles';
import { Modal, Button, Select } from '@v2/components';
import type { SelectOption } from '@v2/components';
import { useFilterForm } from './useFilterForm';

const filterTypeOptions: SelectOption[] = [
  { value: 'instance', label: 'Instance ID' },
  { value: 'pims', label: 'PIMS' },
];

const AddFilterModal: React.FC<AddFilterModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  pimsList,
  editFilter,
}) => {
  const { form, filterType, errors, handleSubmit } = useFilterForm({
    isOpen,
    editFilter,
    onSubmit,
    onClose,
  });

  const { register } = form;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={editFilter ? 'Edit Filter' : 'Add Filter'}
      footer={
        <div className={styles.footer}>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            {editFilter ? 'Update' : 'Add'}
          </Button>
        </div>
      }>
      <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.fieldGroup}>
          <Select
            {...register('filterType')}
            id="filter-type"
            label="Filter Type"
            options={filterTypeOptions}
            disabled={!!editFilter}
            error={errors.filterType?.message}
          />
        </div>

        {filterType === 'instance' && (
          <div className={styles.fieldGroup}>
            <label className={styles.label}>Instance IDs (comma separated)</label>
            <textarea
              {...register('instanceText')}
              className={errors.instanceText ? styles.textareaError : styles.textarea}
              rows={10}
              placeholder={
                '550e8400-e29b-41d4-a716-446655440000,\n660e8400-e29b-41d4-a716-446655440001'
              }
            />
            {errors.instanceText && (
              <span className={styles.errorHint}>{errors.instanceText.message}</span>
            )}
            <span className={styles.hint}>Enter valid GUIDs separated by commas</span>
          </div>
        )}

        {filterType === 'pims' && (
          <div className={styles.fieldGroup}>
            <label className={styles.label}>PIMS (Ctrl + click to select multiple)</label>
            <select {...register('selectedPims')} className={styles.multiSelect} multiple size={10}>
              {pimsList.map(pims => (
                <option key={pims.id} value={pims.name}>
                  {pims.name}
                </option>
              ))}
            </select>
            {errors.selectedPims && (
              <span className={styles.errorHint}>{errors.selectedPims.message}</span>
            )}
          </div>
        )}
      </form>
    </Modal>
  );
};

export default AddFilterModal;
